import React from "react";
import { ListItem } from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import { useSelector } from "react-redux";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));
const CategoriesFilter = ({ categoriesToApply, setCategoriesToApply }) => {
  const classes = useStyles();
  //REDUX
  const themeColor = useSelector((state) => state.store.store.settings?.dark);
  const language = useSelector((state) => state.store.language);
  const categories = useSelector((state) => state.store.store.categories);
  const settings = useSelector((state) => state.store.store.settings);

  //COMPONENT STATE
  const [open, setOpen] = React.useState(false);

  //COMPONENT FUNCTIONS
  const handleClick = () => {
    setOpen(!open);
  };

  const checkLayoutFilter = (category) => {
    if (
      settings.store_layout === "grid" ||
      settings.store_layout === "grid2" ||
      settings.store_layout === "scroll"
    ) {
      return !category.has_children;
    } else {
      return category.products.length !== 0;
    }
  };

  const isCategorySelected = (categoryId) => {
    return categoriesToApply.some((id) => id === categoryId);
  };

  const handleSelectFilter = (value) => {
    if (categoriesToApply.some((category) => category === value)) {
      setCategoriesToApply(
        categoriesToApply.filter((category) => category !== value)
      );
    } else {
      setCategoriesToApply([...categoriesToApply, value]);
    }
  };

  return (
    <>
      <ListItem
        button
        onClick={handleClick}
        style={{
          paddingLeft: language === "arabic" ? "" : 0,
          paddingRight: language === "arabic" ? 0 : "",
          marginTop: 15,
          direction: language === "arabic" ? "rtl" : "ltr",
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              height: "26px",
              width: "6px",
              backgroundColor:
                categoriesToApply.length !== 0 ? themeColor : "transparent",
            }}
          ></div>
          <span
            style={{
              flex: 1,
              marginLeft: language === "arabic" ? 0 : 16,
              marginRight: language === "arabic" ? 16 : 0,
              fontWeight: "bold",
              fontSize: "15px",
              textAlign: language === "arabic" ? "right" : "left",
            }}
          >
            {language === "arabic" ? "الاصناف" : "Categories"}
          </span>
          {categoriesToApply.length !== 0 && (
            <FiberManualRecordIcon
              style={{
                fontSize: 14,
                color: themeColor,
                marginRight: language === "arabic" ? 0 : 10,
                marginLeft: language === "arabic" ? 10 : 0,
              }}
            />
          )}
        </div>
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {categories
            .filter(
              (category) =>
                checkLayoutFilter(category) &&
                category.id !== "newest" &&
                category.id !== "most-selling"
            )
            .map((category) => (
              <ListItem
                style={{
                  direction: language === "arabic" ? "rtl" : "ltr",
                  paddingLeft: language === "arabic" ? "" : 0,
                  paddingRight: language === "arabic" ? 0 : "",
                  textAlign: language === "arabic" ? "right" : "left",
                }}
                button
                className={classes.nested}
                onClick={() => handleSelectFilter(category.id)}
              >
                <div
                  style={{
                    height: "26px",
                    width: "6px",
                    backgroundColor: isCategorySelected(category.id)
                      ? themeColor
                      : "transparent",
                  }}
                ></div>
                <ListItemText
                  style={{
                    marginLeft: language === "arabic" ? 0 : 20,
                    marginRight: language === "arabic" ? 20 : 0,
                    fontSize: "15px",
                  }}
                  primary={
                    language === "arabic"
                      ? category.ar_name
                      : category.name.charAt(0).toUpperCase() +
                        category.name.slice(1)
                  }
                />
              </ListItem>
            ))}
        </List>
      </Collapse>
    </>
  );
};

export default CategoriesFilter;
